import React from 'react';
import Datetime from 'react-datetime';

export default class DateField extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            errors: false,
            touched_and_blank: false,
            value: '',
            class_names: '',
        }
    }

    componentDidMount = () => {
        //console.log('DateField componentDidMount');
        this.setState({value: this.props.editingInstance[this.props.field_id]});
    }

    onChange = (e) => {
        // console.log(e);
        // console.log('Here is E');
        // //console.log(e.format('YYYY-MM-DD'));
        // console.log(typeof(e) == 'object')
        // console.log(String(e).split("-").length - 1)
        if (typeof(e) == 'object') {
          let value = String(e.format('YYYY-MM-DD'));
          this.setState({value});
          //let value = e;
          let data_key = this.props.field_id;
          let key = String(this.props.field_id).toLowerCase();
          //console.log('Here is the date field onChange key');
          //console.log(key);
          this.props.onSelectChange(key, value);
          // if (String(value).length > 0 && String(value) !== 'null') {
          //   this.setState({
          //     errors: false,
          //     touched_and_blank: false,
          //     value: value,
          //     class_names: '',
          //   });
          //   this.props.onHandleSuccess(key);
          // }
          // if (!value && this.props.field_required === true) {
          //   this.setState({
          //     errors: true,
          //     touched_and_blank: false,
          //     value: value,
          //     class_names: 'error',
          //   });
          //   this.props.onHandleErrors(key);
          // }
        }
    }

    handleBlur = () => {
        // if (this.props.field_required === true && !this.state.value) {
        //   this.props.onHandleErrors(this.props.data_key);
        //   this.setState({touched_and_blank: true, class_names: 'error'});
        // }
    }

    render() {
        return (
            <Datetime
                key={this.props.field_id + '_datetime_component'}
                dateFormat="YYYY-MM-DD"
                timeFormat={false}
                onChange={this.onChange}
                closeOnSelect={true}
                defaultValue={this.state.value}
                value={this.state.value}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/date_field.js